import React, { useState } from 'react'
import { useParams, useLocation } from 'react-router'
import styled from 'styled-components'
import { LEADERBOARDS_TARGETS } from '../../constants'
import { useCounters, useTreeLeaderboard, useQueryParamLang, useLanguage } from '../../hooks'
import Spacer from '../../components/common/Spacer'
import ButtonGroup from '../../components/leaderboard/ButtonGroup'
import Leaderboard from '../../components/leaderboard/Leaderboard'
import addTreesField from './utils'

const Container = styled.div`
    width: 100%;
    padding-bottom: 10px;
    background-color: ${({ bgColor }) => bgColor};
`

const LeaderboardWidget = () => {
    const { uid } = useParams()
    const { lang } = useQueryParamLang()
    const { t } = useLanguage(lang)

    const urlQuery = new URLSearchParams(useLocation().search)
    const hideButtons = urlQuery.get('hideButtons') || null
    // const bgColor = urlQuery.get('bgColor') || theme.greyLight

    const [target, setTarget] = useState(LEADERBOARDS_TARGETS.TREE_MONTHLY)

    // Get total number of users in order to estimate logged in user's position
    const [countersError, countersLoading, counters] = useCounters()
    const [leadsError, leadsLoading, leads] = useTreeLeaderboard(uid)

    if (countersLoading || leadsLoading) {
        return <Container style={{ textAlign: 'center' }}>{t('loadingComp.title')}</Container>
    }

    const error = countersError || leadsError

    if (error) {
        console.log(error)
        return null
    }

    const { totalLead, monthlyLead, me } = leads // me should be null when uid is not provided

    // Extend all users in the 'leaderboard' as well as 'me' by adding
    // a 'trees' field based on the given target
    const [leaderboard, meExt] = addTreesField({ target, totalLead, monthlyLead, me })

    const BUTTONS = [
        {
            id: LEADERBOARDS_TARGETS.TREE_MONTHLY,
            title: t('leaderboardWidget.lastMonthBtn.title'),
        },
        {
            id: LEADERBOARDS_TARGETS.TREE_TOTAL,
            title: t('leaderboardWidget.totalBtn.title'),
        },
    ]

    return (
        <Container bgColor="#F5F7FE">
            { !hideButtons && (
                <>
                    <ButtonGroup
                        leftTitle={BUTTONS[0].title}
                        rightTitle={BUTTONS[1].title}
                        activeIndex={BUTTONS.findIndex((btn) => btn.id === target)}
                        onClick={(index) => { setTarget(BUTTONS[index].id) }}
                    />
                    <Spacer size="L" />
                </>
            )}
            <Leaderboard
                leaderboard={leaderboard}
                totalUsers={counters.totalUsers}
                me={meExt}
            />
        </Container>
    )
}

export default LeaderboardWidget
